import { Dispatch } from 'redux'

import type {
  TCreateCustomEndpointsBulkBody,
  TUpdateCustomEndpointBody
} from '@homepal/api-contract'
import { CustomEndpointPost } from 'types/GlobalCustomEndpoint'
import { SnackbarMessage } from 'types/GlobalSnackbar'

import {
  create,
  createMany,
  destroy,
  getAll,
  getAllDynamicsEntitySets,
  update
} from 'redux/api/DataPlatform/connections/CustomEndpoints'
import { toggleSnackbarOpen } from '../../../Snackbar'

import * as actions from './actions'

export function tryGetAllCustomEndpoints(activeSourceId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getAll())

    getAll(activeSourceId)
      .then((response) => {
        dispatch(actions.getAllSuccess(response.data))
      })
      .catch(() => {
        dispatch(actions.getAllFailed())
      })
  }
}

export function tryCreateCustomEndpoint(
  body: CustomEndpointPost,
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create(body)
      .then((response) => {
        dispatch(actions.createSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))

        if (callback) {
          callback(true)
        }
      })
  }
}

export function tryCreateCustomEndpoints(
  body: TCreateCustomEndpointsBulkBody,
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.createMany())

    createMany(body)
      .then((response) => {
        dispatch(actions.createManySuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        dispatch(actions.createManyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))

        if (callback) {
          callback(true)
        }
      })
  }
}

export function tryUpdateCustomEndpoint(
  id: string,
  body: TUpdateCustomEndpointBody,
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(id, body)
      .then((response) => {
        dispatch(actions.updateSuccess(response.data))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))

        if (callback) {
          callback(true)
        }
      })
  }
}

export function tryDeleteCustomEndpoint(
  id: string,
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess({ id }))

        dispatch(toggleSnackbarOpen(SnackbarMessage.Success))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(toggleSnackbarOpen(SnackbarMessage.Failed))

        if (callback) {
          callback(true)
        }
      })
  }
}

export function tryGetAllDynamicsEntitySets(activeSourceId: string) {
  return (dispatch: Dispatch) => {
    dispatch(actions.getEntitySets())

    getAllDynamicsEntitySets(activeSourceId)
      .then((response) => {
        dispatch(
          actions.getEntitySetsSuccess({ ...response.data, activeSourceId })
        )
      })
      .catch(() => {
        dispatch(actions.getEntitySetsFailed())
      })
  }
}
